import ErrorPage from 'components/UI/ErrorPage'
import PropTypes from 'prop-types'
import { Routes as ReactRouterRoutes, Route } from 'react-router-dom'

function Routes({ children }) {
  return (
    <ReactRouterRoutes>
      <Route errorElement={<ErrorPage />}>{children}</Route>
    </ReactRouterRoutes>
  )
}

Routes.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Routes
